<template>
  <div class="fill-width mx-2">
    <div>
      <!-- <p class="pa3"><strong> IMEI: </strong>{{ item.imei }}</p> -->
      <w-toolbar class="title4">
        <span class="text-bold">Last Session Report: &nbsp; </span>
        <span :class="classTitle">{{ state }}</span> &nbsp;
        {{ state == "Connected" ? "to" : "from" }} &nbsp;
        <span class="text-bold"> {{ item.baseStationName }}</span>
      </w-toolbar>
    </div>
    <w-flex wrap class="pa5 align-center">
      <table class="xs3 title4">
        <tr
          v-for="row in historyCard({
            start: item.sessionStart,
            stop: item.sessionStop,
          }).rows"
          :key="row.label"
        >
          <td class="text-bold" v-if="row.date">
            {{ row.label }}: &nbsp;&nbsp;
          </td>
          <td v-if="row.date">{{ row.date }} &nbsp;&nbsp;</td>
          <td>
            {{ row.time }}
          </td>
        </tr>
      </table>
      <span class="spacer"></span>
      <div>
        <span v-if="item.sessionStop" class="ml2">
          <strong> Time span: </strong>
          {{ getTime(item.sessionStop - item.sessionStart) }}</span
        >
        <span v-else class="ml2">
          <strong> Current time span: </strong
          >{{ getTime(new Date().getTime() / 1000 - item.sessionStart) }}</span
        >
      </div>

      <span class="spacer"></span>
      <div
        class="xs6"
        v-if="
          item.reasonSessionTerminated &&
          item.reasonSessionTerminated.length > 0
        "
      >
        The connection has been terminated because:
        {{ item.reasonSessionTerminated }}
      </div>
      <div v-else  class="xs6" ></div>
    </w-flex>
    <div class="pa3 w-toolbar--bottom text-left fill-width grey-light5--bg">
     <span v-if="item.totalBytes"> <strong > Data trasmitted: </strong> {{ formatBytes(item.totalBytes) }} Bytes |  <strong > Throughput NTRIP: </strong> {{ formatBytesPerSecond(
                item.totalBytes / ((item.sessionStop?item.sessionStop:lastRefresh.getTime()/1000) - item.sessionStart)
              ) }}  |  </span>
      <strong> Hardware Model:</strong> {{ item.hardwareModel }} |
      <strong> NTRIP: </strong>{{ item.ntripVersion }} ver.
    </div>
  </div>
</template>

<script>
import {
  dateTimeFormat,
  timeformatt,
  dateformatt,
  getTime,
} from "@/utils/time-formatter";

import { formatBytesPerSecond,formatBytes } from "@/utils/unit-formatter";
import { optionsStore } from "@/store/options";
import { SessionData } from "@/models/RobotResponse";
import {
  ref,
  //   reactive,
  //   onMounted,
  //   watch,
  computed,
} from "vue";
export default {
  name: "SessionReport",
  props: {
    item: SessionData,
    lastRefresh: Date
  },
  setup: (props) => {
    const now = ref(new Date().getTime() / 1000);
    const state = computed(() =>
      props.item.sessionStart && !props.item.sessionStop
        ? "Connected"
        : "Disconnected"
    );
    const classTitle = computed(() =>
      props.item.sessionStart && !props.item.sessionStop
        ? "pa1 green-light5--bg"
        : "pa1 red-light5--bg"
    );

    function historyCard(item) {
      return {
        headers: [
          { label: "label", key: "label" },
          { label: "date", key: "date" },
          { label: "time", key: "time" },
          { label: "dateTime", key: "dateTime" },
        ],
        rows: [
          {
            label: "End",
            date: dateformatt(
              item.stop,
              optionsStore.getState().locale,
              optionsStore.getState().timezone
            ),
            time: timeformatt(
              item.stop,
              optionsStore.getState().locale,
              optionsStore.getState().timezone
            ),
            dateTime: dateTimeFormat(
              item.stop,
              optionsStore.getState().locale,
              optionsStore.getState().timezone
            ),
          },
          {
            label: "Start",
            date: dateformatt(
              item.start,
              optionsStore.getState().locale,
              optionsStore.getState().timezone
            ),
            time: timeformatt(
              item.start,
              optionsStore.getState().locale,
              optionsStore.getState().timezone
            ),
            dateTime: dateTimeFormat(
              item.stop,
              optionsStore.getState().locale,
              optionsStore.getState().timezone
            ),
          },
        ],
      };
    }
    return {
      state,
      classTitle,
      historyCard,
      getTime,
      now,
      formatBytesPerSecond,
      formatBytes
    };
  },
};
</script>
<style scoped>
.w-card__content {
  padding: 0px;
  flex-grow: 1;
}
</style>
